import axios from '../http'
import {changeCartGoodsNum} from '../../common/bus'
import {API} from "../const"

const api = API+'/carts/';

const error = (name) => (e) => console.error(name + ':=>', e);

export function saveAll(list, cb, fcb = error('saveAll')) {
  // axios.all(list.map(params => axios.post(api, params)))
  //   .then(axios.spread(function (d) {
  //     changeCartGoodsNum0();
  //     // 多个请求现在都执行完成
  //     cb(d);
  //   })).catch(d => fcb(d));
  axios.post(api + "all", list).then(res => {
    changeCartGoodsNum0();
    cb(res)
  }).catch(d => fcb(d));
}

export function save(params, cb, fcb = error('save')) {
  axios.post(api, params).then(d => {
    changeCartGoodsNum0();
    cb(d);
  }).catch(d => fcb(d));
}

export function deleteCartAll(list, cb, fcb = error('deleteCartAll')) {
  axios.all(list.map(params => axios.delete(api, {params})))
    .then(axios.spread(function (d) {
      // 多个请求现在都执行完成
      changeCartGoodsNum0();
      cb(d)
    // })).catch(d => fcb(d));
      })).catch(d => {
        changeCartGoodsNum0();
        cb(d)
      });
}


export function listCurrentUserCart(cb, fcb = error('listCurrentUserCart')) {
  axios.get(api).then(d => {
    d.data.forEach(cart => {
      cart.checked = false;
      cart.checkedArray = [];
    });
    cb(d.data)
  }).catch(d => fcb(d))
}

export function initCartGoodsNum() {
  changeCartGoodsNum0();
}

function countCartGoodsNum(cb, fcb = error('countCartGoodsNum')) {
  axios.get(api + 'count-goods-num').then(d => {
    cb(d.data)
  }).catch(d => fcb(d))
}

function changeCartGoodsNum0() {
  countCartGoodsNum(goodsNum => {
    changeCartGoodsNum(goodsNum);
  })
}


